import React from 'react'


const SignIn = () => { 
  return (
    <div className="pt-24">
      <form>
        <h1>SignIn</h1>
        
      </form>  
      
    </div>
  )
}

export default SignIn